import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import Cupshe, { Track } from "cupshe-element";
import qs from "query-string";
import "cupshe-element/lib/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import locale from "./locale";
import "./utils/i18n.js";
import "./assets/font/font.css";
import { trackOption } from "./utils/track-options";
import "windi.css";

const href = location.href.split("?")[1];
const query = qs.parse(href);
let lang = "us";

for (let i in locale) {
  if (locale[i].siteId === query.siteId) {
    lang = i;
  }
}
let shopId = query.siteId;
if (window.location.href.indexOf("cupshe.com") === -1) {
  shopId = "9991";
}
!(function (c, u, p, s, e, v, n, t) {
  if (c.cps) return;
  v = c.cps = function () {
    v.invoke ? v.invoke.apply(v, arguments) : v.qu.push(arguments);
  };
  v.push = v;
  v.qu = [];
  v("init", e, new Date().getTime());
  n = u.createElement(p);
  n.async = 1;
  n.src = s;
  t = u.getElementsByTagName(p)[0];
  t.parentNode.insertBefore(n, t);
})(window, document, "script", "https://analysis.cupshe.com/js/cps.js", shopId);

const i18n = createI18n({
  locale: lang,
  fallbackLocale: "us",
  messages: locale,
});

createApp(App)
  .use(Track, trackOption)
  .use(Cupshe)
  .use(store)
  .use(i18n)
  .use(router)
  .mount("#app");
